import { formatDefaultLocale } from 'd3-format';
import { scaleSqrt } from 'd3-scale';
import debounce from 'lodash.debounce';

const germanNumberFormat = formatDefaultLocale({
  decimal: ',',
  thousands: '.',
  grouping: [3],
  currency: ['€', ''],
});

export function numberFormat(num, decimals = 0, unit = false) {
  if (typeof num === 'undefined') {
    return '';
  }

  const formattedNumber = germanNumberFormat.format(`,.${decimals}f`)(num);

  return unit ? `${formattedNumber} ${unit}` : formattedNumber;
}

export function normalizeInput(input) {
  return `${input}`.toLowerCase().trim();
}

export function getDirectMatches(input, data) {
  const normalizedInput = normalizeInput(input);
  return data.filter((d) => d.normalizedLabel.indexOf(normalizedInput) === 0);
}

export function translate(x, y) {
  return `translate(${x}, ${y})`;
}

const sectors = {
  1: 'Land- und Forstwirtschaft',
  2: 'Verarbeitendes Gewerbe',
  3: 'Bauwirtschaft',
  4: 'Informatik und Naturwissenschaft',
  5: 'Logistik und Sicherheit',
  6: 'Kaufleute und Verwaltung',
  7: 'Kaufleute und Verwaltung',
  8: 'Gesundheit, Soziales, Lehre',
  9: 'Medien und Kultur',
};

export function getSectorLabel(id) {
  return sectors[id] || 'Alle';
}

const qualifications = {
  Helfer: 'ohne Ausbildung',
  Fachkraft: 'mit Ausbildung',
  Spezialist: 'mit Fortbildung/Bachelor',
  Experte: 'mit Master/Diplom',
};

export function getQualificationLabel(id) {
  return qualifications[id] || 'Alle';
}

export function getRScale() {
  return scaleSqrt().domain([0, 1000000]).range([1, 15]).clamp(true);
}

function resizeIframe() {
  window.parent.postMessage(
    {
      idwBerufeFrameHeight: document.body.clientHeight,
    },
    '*'
  );
}

export const resizeIframeDebounced = debounce(resizeIframe, 100);

export function isIFrame() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

export default {
  numberFormat,
  normalizeInput,
  getDirectMatches,
  translate,
  getSectorLabel,
  getQualificationLabel,
  getRScale,
  resizeIframeDebounced,
};
